<template>
    <div class="zz-select-dropdown"
    :class="className" :style="styles"><slot></slot>
 </div>
</template>
<script>
import Vue from 'vue';
const isServer=Vue.prototype.$isServer;
import{ getStyle } from '../../utils/assist';
const Popper = isServer ? function(){}:require('popper.js/dist/umd/popper.js');
import { transferIndex, transferIncrease }from '../../utils/transfer-queue'; 
import{findComponentUpward } from '../../utils/assist';

export default {
    name: 'Drop',
    props: {
        placement: {
            type: String,
            default: 'bottom-start'
        },
        className:{
            type: String
        },
        transfer:{
            type:Boolean
        },
        offset:{
            default:0
        }
    },
    data(){
        return {
            popper: null, 
            width: '',
            popperStatus:false,
            tIndex:this.handleGetIndex(),
        };
    },
    computed:{
        styles(){
            let style = {};
            if(this.width)style.width=`${this.width}px`;
            if(this.transfer){
                const modal=findComponentUpward(this, 'Modal'); 
                if(modal){
                    this.tIndex =this.tIndex +0;
                    style['z-index'] = 1060 + this.handleGetIndex()+10000;
                } else {
                    style['z-index']= 1060 + this.tindex;
                }
            }
            return style;
        }
    },
    methods: {
        update(){
            if (isServer) return; 
            if (this.popper){
                this.$nextTick(()=>{
                    this.popper.update();
                    this.popperStatus= true;
                }); 
            } else {
                this.$nextTick(()=>{
                    this.popper = new Popper(this.$parent.$refs.reference, this.$el, {
                        placement: this.placement,
                        modifiers:{
                            computeStyle:{
                                gpuAcceleration: false,
                            },
                            preventOverflow:{
                                boundariesElement:'window',
                            },
                            offset:{
                                offset:this.offset
                            }
                        },
                        onCreate:()=>{
                            this.resetTransformOrigin();
                            this.$nextTick(this.popper.update());
                        },
                        onUpdate:()=>{
                            this.resetTransformOrigin();
                        }
                    });
                });
            }
            // set a height for parent is Modal and lect's width is 100% 
            if(this.$parent.$options.name === 'zSelect' || this.$parent.$options.name === 'filterSelect'){ 
                this.width =parseInt(getStyle(this.$parent.$el, 'width'));
            }
            this.tIndex=this.handleGetIndex();
        },
        destroy(){
            if(this.popper){ 
                setTimeout(()=>{
                    if(this.popper && !this.popperStatus){
                        this.popper.destroy();
                        this.popper =null;
                    }
                    this.popperStatus = false; 
                }, 300);
            }
        },
        resetTransformOrigin(){
            // 不判断，Select 会报错 不知道为什么 
            if(!this.popper) return;
            let x_placement = this.popper.popper.getAttribute('x-placement');
            let placementStart = x_placement.split('-')[0];
            let placementEnd = x_placement.split('-')[1];
            const leftOrRight = x_placement === 'left' || x_placement === 'right';
            if(!leftOrRight){
                this.popper.popper.style.transformOrigin= placementStart=== 'bottom' || (placementStart !== 'top' && placementEnd==='start') ? 'center top': 'center bottom';
            }
        },
        handleGetIndex(){

            transferIncrease(); 
            return transferIndex;
        }
    },

    created(){
        this.$on('on-update-popper',this.update);
        this.$on('on-destroy-popper', this.destroy); 
    },
    beforeDestroy(){
        if(this.popper){
            this.popper.destroy();
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/select/dropdown.vue